import Layout from "../../Layout/Layout";
import ProfileCard from "./profile-card";
import LevelsGrid from "./levels-grid";
import LeaderboardSection from "./leaderboard-section";
import { useGetProfile } from "../../Controllers/UserProfileController";
import { useLeaderboardDetail } from "../../Controllers/Tribe/LeaderboardController";
import { useNavigate } from "react-router-dom";

export default function Leaderboards() {
  const { data, isLoading: isProfileLoading } = useGetProfile();
  const { data: leaderboardData, isLoading: isLeaderboardLoading } =
    useLeaderboardDetail();
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="container-fluid" style={{ padding: "24px" }}>
        {isProfileLoading || isLeaderboardLoading ? (
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        ) : (
          <>
            <div className="row g-4 mb-4">
              <div className="col-lg-4 d-flex flex-column">
                <div className="d-flex flex-column mb-4">
                  <h1
                    style={{
                      fontSize: 24,
                      fontWeight: 700,
                      color: "#E6ECF1",
                      marginBottom: 4,
                    }}
                  >
                    Leaderboards
                  </h1>
                  <p
                    style={{
                      color:
                        "color-mix(in srgb, var(--Primary-500), transparent 40%)",
                      margin: 0,
                    }}
                  >
                    Track your progress and compete with others
                  </p>
                </div>

                <ProfileCard
                  user={data}
                  level={leaderboardData?.authUserLevelDetails}
                  leaderboardData={leaderboardData}
                />
              </div>

              <div className="col-lg-8">
                <LevelsGrid
                  levels={leaderboardData?.levelDetails}
                  currentLevel={leaderboardData?.authUserLevelDetails?.level}
                />
              </div>
            </div>

            {/* <p
              style={{
                marginBottom: 16,
                fontSize: 12,
                color: "color-mix(in srgb, var(--Primary-500), transparent 40%)",
              }}
            >
              Last updated: Oct 21st 2025 3:07pm
            </p> */}

            <div className="row g-3">
              {leaderboardData?.leaderBoardData?.map((leaderboard, idx) => (
                <div key={idx} className="col-md-6 col-lg-4">
                  <LeaderboardSection
                    title={leaderboard.title}
                    data={leaderboard.data}
                    userRank={leaderboard.userRank}
                    userName={data?.full_name}
                    userPoints={leaderboard.userPoint ?? 0}
                    userImage={data?.image}
                  />
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </Layout>
  );
}
